import './index.less';
import i18n from './i18n.json';
import Service from './service';

const { Feature, meta, hook, event } = checkApp.core; //eslint-disable-line
const { Button, Tooltip } = checkApp.components;//eslint-disable-line
const { utils, aplus } = checkApp.common;//eslint-disable-line

const DOMAIN_MAX_LEN = 36;

@meta('recommend', ['service', 'cart', 'request'], 1, i18n)
export default class RecommendFeature extends Feature {

  @event('recommend.inject')
  createService() {
    this.recommendService = new Service(this);
  }

  /**
   * 在 check 触发时，通过 keyword 查询推荐域名
   * @param {event} e check 事件对象
   * @returns {vodi} 无返回
   */
  @event('checkBox.check')
  async getRecommend(e) {
    let keyword = e.detail.args.keyword;
    if (!keyword) return;
    await this.startLoading();
    let list = [], loading = true;
    await this.setState({ list, loading }, { scoped: true });
    const offset = 0;
    const pageSize = 6;
    list = await this.recommendService
      .getRecommend(keyword, { offset, pageSize });
    loading = false;
    await this.checkCart(list);
    await this.setState(
      { list, loading, keyword, offset, pageSize },
      { scoped: true });
    await this.stopLoading();
  }

  refresh = async () => {
    await this.startLoading();
    let {
       keyword, offset, pageSize
    } = this.getState({ scoped: true });
    offset += pageSize;
    const list = await this.recommendService
      .getRecommend(keyword, { offset, pageSize });
    await this.setState(
      { list, keyword, offset, pageSize },
      { scoped: true });
    await this.stopLoading();
  }

  startLoading() {
    return this.setState({ loading: true, list: [] }, { scoped: true });
  }

  stopLoading() {
    return this.setState({ loading: false }, { scoped: true });
  }

  /**
   * 检查域名列表是否在购物车中
   * @param {Array<object>} list 推荐域名列表
   * @returns {void} 无返回
   */
  async checkCart(list) {
    await Promise.all(list.map(item => {
      return (async () => {
        item.added = await this.cart.has(item);
      })();
    }));
  }

  /**
   * 从购物车中，添加或移除一个域名
   * @param {object} item 域名项
   * @returns {void} 无返回
   */
  toggleCart(item) {
    if (item.added) {
      this.cart.remove(item);
      item.added = false;
    } else {
      this.cart.add(item);
      item.added = true;
    }
  }

  /**
   * 渲染添加或移除购物车按钮
   * @param {object} item 域名项
   * @returns {object} 按钮 dom
   */
  renderButton(item) {
    let action = item.added ? 'remove' : 'add';
    return <a onClick={this.toggleCart.bind(this, item)}
      href="javascript:;"
      data-spm-click={aplus(`rd-${action}-${item.suffix}`)}
      className={
        `btn btn-${item.added ? 'link' : 'primary'} 
        pull-right hollow shopping-cart-hide-prevent`
      }>
      {this.locale(action)}
    </a>;
  }

  /**
   * 渲染推荐域名列表
   * @param {Array<object>} list 域名列表
   * @returns {object} 域名列表 dom
   */
  renderList(list) {
    return <ul className="check-list">
      {list.map(item => (
        <li className="check-item" key={item.name}>
          <span className="domain">
            {utils.short(item.domain, DOMAIN_MAX_LEN)}
          </span>
          {this.renderButton(item)}
          <span className="price">
            ￥{item.prices.activate.tradePrice || 0}/{this.locale('year')}
          </span>
        </li>
      ))}
    </ul>;
  }

  /**
   * 渲染列表长度为 0 时的信息
   * @param {boolean} loading 是否为 Loading 状态
   * @returns {object} dom
   */
  renderEmpty(loading) {
    return <div className="empty">
      {loading ? this.locale('loading') : this.locale('empty')}
    </div>;
  }

  /**
   * 渲染右侧面板
   * @param {object} state 状态对象
   * @returns {objecg} 面板 dom
   */
  @hook('main.renderMainPanel')
  renderMainPanel() {
    const { list = [], loading } =
      this.getState({ scoped: true });
    return <div key={this.id} className="panel side recommend">
      <div className="panel-heading">
        <span>{this.locale('title')}</span>
        <a className="pull-right refresh" onClick={this.refresh}>
          <i className="glyphicon glyphicon-repeat" aria-hidden="true"></i>
          换一批试
        </a>
      </div>
      {list && list.length > 0 ?
        this.renderList(list) :
        this.renderEmpty(loading)}
    </div>;
  }

  @event('cart.change')
  async updateListState(event) {
    //console.log('cart.change:', 'updateListState', event);
    const { list = [] } = this.getState({ scoped: true });
    if (list.length < 1) return;
    let changedList = event.detail;
    await Promise.all(list.map(item => {
      if (changedList && !changedList.includes(item.domain)) return;
      return (async () => {
        item.added = await this.cart.has(item);
      })();
    }));
    this.setState({ list }, { scoped: true });
  }

}


// WEBPACK FOOTER //
// ./src/recommend/index.js